module.exports = __webpack_public_path__ + "static/media/logo.24a82161.png";